import { Moment } from 'moment';
import { EventVertical, EventType, EventOccasion } from '../../../meta/meta.types';
import { GeoLocation } from '../../../common/common.types';

export class NewEventInvitation {
	customerIds?: number[];
	type?: EventInvitationType;
	theme?: EventInvitationTheme;
	eventName: string;
	timeframe: string;
	message: string;
	sentBy: string;
}

export class EventInvitation {
	eventId: number;
	extendedEventId: string;

	theme?: EventInvitationTheme;
	vertical: EventVertical;
	type: EventType;
	occasion: EventOccasion;

	name: string;
	startsOn?: string | Moment;
	endsOn?: string | Moment;
	isSingleDay: boolean;
	timeframe: string;
	timezone: string;

	location: GeoLocation;

	invitee: EventInvitationCustomer;
	inviter?: EventInvitationCustomer;
}

export class EventInvitationCustomer {
	name: string;
	email: string;
	phone: string;
}

export class EventInvitationAnswer {
	isComing: boolean;
	attendeeDetails?: {
		[key: string]: string;
	};
}

export enum EventInvitationTheme {
	Wine = 0,
	Kids = 1
}

export enum EventInvitationType {
	Email = 0,
	SMS = 1
}
